/**
 * Единое поле настроек: лейбл, контент (input/select), описание (опционально).
 * Используется для полей формы агента (модель, max tokens, temperature и т.д.).
 *
 * labelWraps: когда false — обёртка div, не label. Нужно для полей с несколькими
 * контролами (ConditionBuilder и т.п.): иначе клик по label активирует первый
 * контрол (первый Select), и селекты открываются при клике по экрану.
 */
export default function SettingsField({ label, hint, children, labelWraps = true }) {
  const header = (
    <span className="settings-field-header">
      <span className="settings-field-label">{label}</span>
      {hint && <span className="settings-field-hint">{hint}</span>}
    </span>
  )
  const control = <div className="settings-field-control">{children}</div>

  if (labelWraps) {
    return (
      <label className="settings-field">
        {header}
        {control}
      </label>
    )
  }
  return (
    <div className="settings-field" role="group">
      {header}
      {control}
    </div>
  )
}
